import { InteractionConfig } from './types';
import { AnimatePresence, motion } from 'framer-motion';

export default function Interaction(props: {
	shouldPlay: boolean;
	config: InteractionConfig;
	onLoaded: () => void;
	onDone: () => void;
	onError: (e: Error) => void;
}) {
	// call after preloading is done
	props.onLoaded();
	// call onDone when your interaction is done or after some timeout
	setTimeout(() => {
		props.onDone();
	}, props.config.timeout);

	const horizontal = props.config.mirrored ? 'left' : (props.config.horizontal || 'right');

	return (
		<AnimatePresence>
			<div className="relative w-full h-full">
				<audio src="/harpdream.wav" autoPlay={true} />
				<div className={`w-full absolute -top-[250px] -left-[250px]`}>
					<motion.div
						initial={{ opacity: 0, y: 5 }}
						exit={{ opacity: 0, y: 5 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.6, delay: 0 }}
						className={`text-center text-3xl font-semibold w-[500px] self-center relative`}
					>
						<motion.div
							initial={{ opacity: 0 }}
							exit={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							transition={{ duration: 0.6, delay: 0.9 }}
							className={`w-full bg-white rounded-full px-4 py-3 absolute top-[40px] z-50 h-[180px] flex text-center`}
						>
							<div className="h-full flex justify-center items-center align-middle w-full">
								<p className="items-center justify-center align-middle text-center z-50">{props.config.msg}</p>
							</div>
						</motion.div>
						<motion.div
							initial={{ opacity: 0, y: 5 }}
							exit={{ opacity: 0, y: 5 }}
							animate={{ opacity: 1, y: 0 }}
							transition={{ duration: 0.6, delay: 0.6 }}
							className={` w-[90px] h-[90px] rounded-full bg-white absolute top-[180px] z-0 ${horizontal === 'right' ? '-left-[10px]' : '-right-[10px]'}`}
						></motion.div>
						<motion.div
							initial={{ opacity: 0, y: 5 }}
							exit={{ opacity: 0, y: 5 }}
							animate={{ opacity: 1, y: 0 }}
							transition={{ duration: 0.6, delay: 0.3 }}
							className={` w-[65px] h-[65px] rounded-full bg-white absolute top-[250px] z-0 ${horizontal === 'right' ? '-left-[20px]' : '-right-[20px]'}`}
						></motion.div>
					</motion.div>
				</div>
			</div>
		</AnimatePresence>
	);
}
